export const PAGE_TOPIC = '/topic';
